import { Component, Input, OnDestroy, OnInit, inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { getStyleObjectFromUrl, StyleObject } from '@outlaw/core';
import { StreamComponent } from '../stream/stream.component';
import { FullScreenPlayService } from '../../services/util/full-screen-play.service';

@Component({
  selector: 'app-full-screen-video',
  templateUrl: './full-screen-video.component.html',
  styleUrls: ['./full-screen-video.component.scss'],
  imports: [StreamComponent],
})
export class FullScreenVideoComponent implements OnInit, OnDestroy {
  public fullScreenService = inject(FullScreenPlayService);
  private document = inject<Document>(DOCUMENT);
  @Input() isWebView = false;

  title: string;
  streamUrl: string;
  isActivePlay = false;
  hideHeaderTimer: number;
  hiddenFullscreenHeader = false;
  bodyEl: HTMLBodyElement;
  previewStyleObject: StyleObject;
  private destroy$ = new Subject<void>();
  isAndroid = navigator.userAgent.toLowerCase().indexOf('android') > -1;
  needWebViewHack = false;

  ngOnInit(): void {
    this.bodyEl = this.document.getElementsByTagName('body')[0];
    this.needWebViewHack = this.isWebView && this.isAndroid;

    this.fullScreenService.isActivePlay.pipe(takeUntil(this.destroy$)).subscribe(videoData => {
      if (videoData) {
        this.isActivePlay = true;
        this.title = videoData.title;
        this.streamUrl = videoData.streamUrl;
        this.previewStyleObject = this.getPreviewStyles(videoData.thumbnail);
        this.bodyEl.classList.add('hide-overflow');
      } else {
        this.isActivePlay = false;
        this.bodyEl.classList.remove('hide-overflow');
      }
    });
  }

  closeVideoPlayer(): void {
    this.fullScreenService.stopFullScreenPlay();
  }

  hideHeaderTimerExecute(): void {
    clearTimeout(this.hideHeaderTimer);
    this.hiddenFullscreenHeader = false;
    this.hideHeaderTimer = window.setTimeout(() => (this.hiddenFullscreenHeader = true), 1500);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.bodyEl.classList.remove('hide-overflow');
  }

  getPreviewStyles(preview: string): StyleObject {
    if (!preview || preview === 'None') {
      return {};
    }
    return getStyleObjectFromUrl(preview);
  }
}
